/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import PropTypes from "prop-types"
import React from "react"
import Banner from "./banner"
import Header from "./header"
import "./layout.css"
import SEO from "./seo"

// eslint-disable-next-line
React

const Layout = ({ children, location }) => {
  return (
    <>
      <Banner />
      <SEO />
      <div id="wrapper">
        <Header location={location} />
        <main id="page">{children}</main>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
